<template lang="html">
  <d-select v-model="selectedSeller">
    <option v-if="defaulOption" disabled value="" selected>{{ label }}</option>
    <option
      :value="seller.id"
      v-for="(seller, index) in sellerList"
      :key="index"
      :hidden="seller.deleted_at"
    >{{ seller.name }}</option>
  </d-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'select-seller',
  props: {
    model: {
      type: [Number, String],
    },
    defaulOption: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Selecione uma opção',
    },
  },
  computed: {
    sellerList() {
      const { sellerList } = this.$store.state.user;
      if (sellerList && sellerList.length) {
        return sellerList;
      }
      return [];
    },
    selectedSeller: {
      get() {
        return this.model;
      },
      set(value) {
        return this.$emit('update:model', value);
      },
    },
  },
  methods: {
    ...mapActions([
      'getSellerList',
    ]),
    getListUser() {
      if (this.sellerList.length === 0) {
        this.getSellerList();
      }
    },
  },
  mounted() {
    this.getListUser();
  },
};
</script>
